<div class="{{isAuthenticated ? 'corner-ribbon' : 'corner-ribbon-login'}} sticky {{environmentRibbonBackground}}" *ngIf="environmentRibbonText && environmentRibbonBackground">{{environmentRibbonText}}</div>
